import styled from "@emotion/styled"

const HeaderWrapper = styled.header`
  top: 0;
  z-index: 10;
  width: 100vw;
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease;

  ${({ isScrolled, hasScroll, theme }) => {
    if (!hasScroll) {
      return `
        background-color: ${theme.palette.gray["50"]};
         position: sticky;
        ${theme.breakpoints.down("xl")} {
          box-shadow: 0 12px 30px rgba(118, 118, 129, 0.15);
        }

        ${theme.breakpoints.up("xl")} {
          box-shadow: rgba(0, 0, 0, 0.1) 0px 0.0625rem 0.375rem 0px;
        }
      `
    }
    const isSticky = isScrolled
    return `
        background-color: ${isSticky ? theme.palette.gray["50"] : "transparent"};
        box-shadow: ${isSticky ? "0 12px 30px rgba(118, 118, 129, 0.15)" : "none"};
        position: fixed;

        ${
          !isSticky
            ? `
        &:hover {
          background-color: ${theme.palette.gray["50"]};
          box-shadow: 0 12px 30px rgba(118, 118, 129, 0.15);
        }
      `
            : ""
        }
      `
  }}
`

export default HeaderWrapper
